import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IProductData } from '../../index';

export interface IGetAllProductRequestAction {
  data: {
    description?: string;
    ean?: string;
    manufacturer?: string;
    page?: number;
    sku?: string;
  };
  functions: {
    error: (err: any) => void;
  };
}

function getAllRequest(
  draft: Draft<IProductData>,
  action: PayloadAction<IGetAllProductRequestAction>,
) {
  draft.getAll.config.errorMessage = '';
  draft.getAll.config.emptyMessage = '';
  draft.getAll.config.isLoading = true;
  draft.getAll.config.pagination.totalPages = 1;
  draft.getAll.config.pagination.page = action.payload.data.page;
  draft.getAll.list = [];
}

export default getAllRequest;
